import React, {Component, Fragment} from 'react';
import {CardTitle, Nav, NavItem, NavLink, TabContent, TabPane} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import classnames from "classnames";
import List from "./list";

class Boards extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0,
    };
  }

  toggle = tabIndex => {
    this.setState({
      activeTab: tabIndex,
    });
  };

  render() {
    const {t, id} = this.props;
    const {activeTab} = this.state;
    return (
      <Fragment>
        <CardTitle className="text-large text-primary d-flex flex-row align-items-center mt-4">
          {t('Campaign Users List')}
        </CardTitle>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === 0 })}
              onClick={() => {this.toggle(0);}}>
                <span className="text-one cursor-pointer">
                  {t('Top Scores')}
                </span>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === 1 })}
              onClick={() => {this.toggle(1);}}>
                <span className="text-one cursor-pointer">
                  {t('Lowest Scores')}
                </span>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === 2 })}
              onClick={() => {this.toggle(2);}}>
                <span className="text-one cursor-pointer">
                  {t('Top Displacements')}
                </span>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === 3 })}
              onClick={() => {this.toggle(3);}}>
                <span className="text-one cursor-pointer">
                  {t('New Arrivals')}
                </span>
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId={0}>
            <List type="TOP_USERS" id={id}/>
          </TabPane>
        </TabContent>
        <TabContent activeTab={activeTab}>
          <TabPane tabId={1}>
            <List type="BOTTOM_USERS" id={id}/>
          </TabPane>
        </TabContent>
        <TabContent activeTab={activeTab}>
          <TabPane tabId={2}>
            <List type="TOP_DISPLACEMENTS" id={id}/>
          </TabPane>
        </TabContent>
        <TabContent activeTab={activeTab}>
          <TabPane tabId={3}>
            <List type="ADDED_USERS" id={id}/>
          </TabPane>
        </TabContent>
      </Fragment>
    );
  }
}

export default withTranslation()(Boards);
